import { FunAr } from "../fun-ar/fun-ar";
export const Compose = (firstFunc, ...additionalFuncs) => (...params) => {
    const firstFuncResponse = firstFunc(...params);
    return additionalFuncs.reduce((arg, fn) => {
        return fn(arg);
    }, firstFuncResponse);
};
export const ComposeAsync = (firstFunc, ...additionalFuncs) => async (...params) => {
    const firstFuncResponse = await firstFunc(...params);
    return FunAr.async.seq.reduce(additionalFuncs, (arg, fn) => {
        return fn(arg);
    }, firstFuncResponse);
};
